import { useEffect, useState } from 'react';
import { fetchHotelSettings, fetchProfile, fetchLicenseRules } from '../services/api';

export default function SettingsPage() {
  const [profile, setProfile] = useState<any>(null);
  const [settings, setSettings] = useState<any>(null);
  const [rules, setRules] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    Promise.all([
      fetchProfile().catch(() => null),
      fetchHotelSettings().catch(() => ({})),
      fetchLicenseRules().catch(() => []),
    ])
      .then(([p, s, r]) => {
        setProfile(p);
        setSettings(s);
        setRules(r);
      })
      .catch(e => setError(e.message))
      .finally(() => setLoading(false));
  }, []);

  if (error) return <div className="error-msg">{error}</div>;
  if (loading) return <div className="loading">Chargement...</div>;

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 24 }}>
      {/* Profile section */}
      <div className="card">
        <h3>Profil de l'établissement</h3>
        <div className="table-wrap" style={{ marginTop: 16 }}>
          <table>
            <tbody>
              <tr><td style={{ fontWeight: 600, width: 200 }}>Nom</td><td>{profile?.name || settings?.hotelName || '–'}</td></tr>
              <tr><td style={{ fontWeight: 600 }}>Email</td><td>{profile?.email || settings?.contactEmail || '–'}</td></tr>
              <tr><td style={{ fontWeight: 600 }}>Téléphone</td><td>{profile?.phone || settings?.contactPhone || '–'}</td></tr>
              <tr><td style={{ fontWeight: 600 }}>Adresse</td><td>{profile?.address || settings?.address || '–'}</td></tr>
              <tr><td style={{ fontWeight: 600 }}>Ville</td><td>{profile?.city || '–'}</td></tr>
              <tr><td style={{ fontWeight: 600 }}>Province</td><td>{profile?.province || '–'}</td></tr>
              <tr><td style={{ fontWeight: 600 }}>Catégorie</td><td>{profile?.category ? `${profile.category} étoiles` : '–'}</td></tr>
              <tr><td style={{ fontWeight: 600 }}>Secteur</td><td>{profile?.sector || '–'}</td></tr>
              <tr><td style={{ fontWeight: 600 }}>Devise par défaut</td><td>{settings?.defaultCurrency || settings?.default_currency || 'USD'}</td></tr>
              <tr><td style={{ fontWeight: 600 }}>Statut</td><td><span className={`badge ${profile?.status === 'active' ? 'green' : 'gray'}`}>{profile?.status || '–'}</span></td></tr>
            </tbody>
          </table>
        </div>
        <div className="sub" style={{ marginTop: 12 }}>
          Pour modifier ces informations, contactez l'administration ONT ou utilisez le portail hôtelier.
        </div>
      </div>

      {/* Preferences section */}
      <div className="card">
        <h3>Préférences du portail</h3>
        <div className="table-wrap" style={{ marginTop: 16 }}>
          <table>
            <tbody>
              <tr><td style={{ fontWeight: 600, width: 200 }}>Check-in par défaut</td><td>{settings?.defaultCheckInTime || settings?.default_check_in_time || '14:00'}</td></tr>
              <tr><td style={{ fontWeight: 600 }}>Check-out par défaut</td><td>{settings?.defaultCheckOutTime || settings?.default_check_out_time || '11:00'}</td></tr>
              <tr><td style={{ fontWeight: 600 }}>QR Code activé</td><td>{settings?.qrCodeEnabled || settings?.qr_code_enabled ? 'Oui' : 'Non'}</td></tr>
              <tr><td style={{ fontWeight: 600 }}>Check-in mobile</td><td>{settings?.mobileCheckInEnabled || settings?.mobile_check_in_enabled ? 'Oui' : 'Non'}</td></tr>
              <tr><td style={{ fontWeight: 600 }}>Scan OCR</td><td>{settings?.ocrScanningEnabled || settings?.ocr_scanning_enabled ? 'Oui' : 'Non'}</td></tr>
              <tr><td style={{ fontWeight: 600 }}>Alertes sécurité</td><td>{settings?.securityAlertsEnabled || settings?.security_alerts_enabled ? 'Oui' : 'Non'}</td></tr>
              <tr><td style={{ fontWeight: 600 }}>Rapports quotidiens</td><td>{settings?.dailyReportsEnabled || settings?.daily_reports_enabled ? 'Oui' : 'Non'}</td></tr>
            </tbody>
          </table>
        </div>
      </div>

      {/* License rules section */}
      <div className="card">
        <h3>Barème des licences</h3>
        <div className="sub">Durées et montants des catégories chargés depuis les règles administratives ONT.</div>
        <div className="table-wrap" style={{ marginTop: 16 }}>
          <table>
            <thead>
              <tr><th>Type d'activité</th><th>Catégorie</th><th>Libellé</th><th>Durée</th><th>Montant</th></tr>
            </thead>
            <tbody>
              {rules.length === 0 && <tr><td colSpan={5} style={{ textAlign: 'center', color: 'var(--muted)' }}>Aucune règle configurée</td></tr>}
              {rules.map((r, i) => (
                <tr key={r.id || i}>
                  <td>{r.activity_type || '–'}</td>
                  <td>{r.category_code || '–'}</td>
                  <td>{r.category_label || '–'}</td>
                  <td>{r.validity_months ? `${r.validity_months} mois` : '–'}</td>
                  <td>{r.renewal_amount != null ? `${r.renewal_amount} ${r.currency || 'USD'}` : '–'}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
